
import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useIsMobile } from "@/hooks/use-mobile";
import Logo from './Logo';
import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [showHeader, setShowHeader] = useState(true);
  const isMobile = useIsMobile();

  const navigation = [
    { name: 'Forside', href: '/' },
    { name: 'Undervisning', href: '/undervisning' },
    { name: 'Om Oscar', href: '/om' },
    { name: 'Blog', href: '/blog' },
    { name: 'Kontakt', href: '/kontakt' },
  ];

  const locationPages = [
    { name: 'Søborg', href: '/klaverundervisning-soborg' },
    { name: 'København', href: '/klaverundervisning-kobenhavn' },
    { name: 'Online', href: '/klaverundervisning-online' },
    { name: 'Gladsaxe', href: '/klaverundervisning-gladsaxe' },
    { name: 'Lyngby', href: '/klaverundervisning-lyngby' },
    { name: 'Gentofte', href: '/klaverundervisning-gentofte' },
    { name: 'Buddinge', href: '/klaverundervisning-buddinge' },
    { name: 'Emdrup', href: '/klaverundervisning-emdrup' },
    { name: 'Vangede', href: '/klaverundervisning-vangede' },
    { name: 'Dyssegård', href: '/klaverundervisning-dyssegard' },
    { name: 'Nordvest', href: '/klaverundervisning-nordvest' },
    { name: 'Nørrebro', href: '/klaverundervisning-norrebro' },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Control header visibility on scroll
  useEffect(() => {
    const controlHeader = () => {
      const currentScrollY = window.scrollY;
      
      // Show header if scrolling up
      if (currentScrollY < lastScrollY) {
        setShowHeader(true);
      } 
      // Hide header if scrolling down and we're past the initial area (100px)
      else if (currentScrollY > 100 && currentScrollY > lastScrollY) {
        setShowHeader(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', controlHeader);
    
    // Clean up
    return () => {
      window.removeEventListener('scroll', controlHeader);
    };
  }, [lastScrollY]);

  return (
    <header className={`sticky top-0 z-50 bg-background border-b border-border py-4 transition-transform duration-300 ${showHeader ? 'translate-y-0' : '-translate-y-full'}`}>
      <div className="container mx-auto px-4 flex justify-between items-center">
        <Logo />

        {/* Desktop Navigation */}
        <DesktopMenu navigation={navigation} locationPages={locationPages} />

        {/* Mobile menu button */}
        <button
          className="md:hidden rounded-md p-2 text-gray-600 hover:bg-gray-100"
          onClick={toggleMenu}
        >
          {isMenuOpen ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      <MobileMenu 
        navigation={navigation} 
        locationPages={locationPages} 
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
      />
    </header>
  );
};

export default Header;
